<template>
  <v-layout v-if="authStore.isLoggedIn" :dir="$root.$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :full-height="true"
    class="rounded rounded-md">

    
    
    
    <v-main class="tw-min-h-screen tw-h-fit tw-overflow-y-auto tw-bg-primary-50">
      <div class="tw-w-full">
        <AppHeader />
      </div>

      <div class="tw-w-full tw-hidden lg:tw-block">
        <AppNavigation />
      </div>

      <div class="tw-max-w-screen-2xl tw-mx-auto tw-w-full tw-mt-5 tw-pb-10">
        <router-view></router-view>
      </div>
    </v-main>
  </v-layout>
</template>

<script setup>
import { useAuthStore } from "@/stores";
import AppHeader from "./partials/AppHeader.vue";
import AppNavigation from "./partials/AppNavigation.vue";
import { companies } from "@/api/me";
import { onMounted } from "vue";
import { useStateStore } from "@/stores/app/state";

const authStore = useAuthStore();
const stateStore = useStateStore();


onMounted(async () => {
  const response = await companies();
  stateStore.setMyCompanies(response.data.companies);
})

</script>

<style>

</style>